import API from '@Services/apiAxios';
import { AISearchRequest, AISearchResult } from './types';

export function searchShipmentHistoryAI(req: AISearchRequest): Promise<AISearchResult> {
  return API.post('/speedboxbot/search/interpret', req).then(res => res.data);
}
